export default __webpack_public_path__ + "static/media/badge.1b21b558.png";